(function () {
    'use strict';

    angular
        .module('app')
        .service('myNewsdeskService', myNewsdeskService);

    myNewsdeskService.$inject = ['$http'];

    function myNewsdeskService($http) {
        /* jshint validthis:true */
        var vm = this;
        var baseUrl = '/api/mynewsdesk';

        vm.getPressReleases = getPressReleases;
        function getPressReleases() {
            return $http.get(baseUrl + '/get-pressreleases');
        }
        vm.getPressRelease = getPressRelease;
        function getPressRelease(id) {
	        console.log(id);
	        return $http.get(baseUrl + '/get-pressrelease/' + id);
        }
    }
})();